import toolkitGreen from '@images/home/toolkit-green.png'
import toolkitBlue from '@images/home/toolkit-blue.png'
import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import UiButtonLinkTo from 'teacher-ui-client/components/ui-button/link-to'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import themeKey from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { concat, hash } from '@ember/helper'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { eq } from 'ember-truth-helpers'

interface Signature {
  Args: {
    subscriptionType: SubscriptionType
  }
}

export class HomeTilesTeacherToolkit extends Component<Signature> {
  get toolkitBluePng() {
    return toolkitBlue
  }

  get toolkitGreenPng() {
    return toolkitGreen
  }

  <template>
    <HomeTile @themeKey={{themeKey @subscriptionType}} @title={{t "pages.home.panels.teacherToolkit.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          {{#if (eq @subscriptionType "reading")}}
            <img class="mr-6" src={{this.toolkitBluePng}} alt={{t "pages.home.panels.teacherToolkit.imageAlt"}} />
          {{else if (eq @subscriptionType "maths")}}
            <img class="mr-6" src={{this.toolkitGreenPng}} alt={{t "pages.home.panels.teacherToolkit.imageAlt"}} />
          {{/if}}
          <p class="mb-3">{{t "pages.home.panels.teacherToolkit.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="subscription-type.teacher-toolkit"
            @query={{hash category=(concat "/" @subscriptionType "/lower")}}
            @appearance={{ButtonAppearance.regular}}
          >
            {{t "pages.home.panels.teacherToolkit.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default HomeTilesTeacherToolkit
